/**
 * Nombre de archivo para descargas de PDF/ZIP de partituras (obra o carpeta).
 * Siempre incluye el instrumento (o «todas»); si hay carpeta, va primero.
 */

export function safePartituraFilenamePart(value, max = 72) {
  return (String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[<>:"/\\|?*\u0000-\u001F]/g, '_')
    .replace(/\s+/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '')
    .slice(0, max) || '');
}

/**
 * @param {{
 *   primary: string,
 *   instrumentLabel?: string | null,
 *   todas?: boolean,
 *   ext?: 'pdf' | 'zip',
 *   dateSuffix?: string | null,
 * }} opts
 * @returns {string}
 */
export function buildPartituraDownloadFilename({
  primary,
  instrumentLabel,
  todas = false,
  ext = 'pdf',
  dateSuffix = null,
}) {
  const base = safePartituraFilenamePart(primary) || 'archivo';
  const inst =
    todas || !String(instrumentLabel || '').trim()
      ? 'todas'
      : safePartituraFilenamePart(instrumentLabel, 48) || 'instrumento';
  const date = dateSuffix ? `_${safePartituraFilenamePart(dateSuffix, 16)}` : '';
  return `${base}__${inst}${date}.${ext}`;
}
